<template>
    <router-link :to="{name: jumpUrl,params: { courseId: course.id}}" class="coursecard">
        <div class="coursecard-bg">
            <img v-if="course.picture" v-lazy="course.picture">
        </div>
        <div class="coursecard-bodybg">
            <div class="coursecard-body">
                <div class="clear">
                    <div class="left"><h3>{{ course.title }}</h3></div>
                </div>
                <router-link :to="{name: 'coachcoursemanage',params: { courseId: course.id}}" class="set"><van-icon name="setting" /></router-link>
            </div>
            <div v-if="course.status == 'published'" class="coursecard-statusbar fs2 mtn">在售</div>
            <div v-else class="coursecard-statusbar coursecard-statusbarwhite fs2 mtn">下架</div>
            <div class="coursecard-footer mtw clear">
                <div class="left fs2">
                    总售出数：{{course.sales}}
                    <br/>
                    评价数：{{course.reviewNum?course.reviewNum:0}}
                </div>
                <div class="right coursecard-footer__price">{{ course.price}} 起/课时</div>
            </div>
        </div>
        
    </router-link>
</template>
<script>
export default {
    name: 'CoachCourseCard',
    props: {
      course: { // 私教课信息
        type: Object,
        required: true
      },
      roles:{
          type:String,
          required: true
      }
    },
    data(){
        return {
            jumpUrl: 'coachcoursemanage',  //跳转路径 默认私教课
        }
    },
    created(){
        if(this.roles == 'ROLE_CLUB_ADMIN'){
            //俱乐部管理员
            this.jumpUrl = 'courseitemmanage'
        }else if(this.roles == 'ROLE_COACH'){
            //教练
            this.jumpUrl = 'coachcoursemanage'
        }
    }
}
</script>
<style lang="less" scoped>
@mg-default:.15rem;
.coursecard{
    display: block;
    position: relative;
    height: 1.2rem;
    margin-top: .15rem;
    padding:.1rem;
    font-size: .16rem;
    background-color: #fff;
    border-radius: .03rem;
    box-shadow: rgba(0,0,0,.2) 0 0 .05rem;
    color: white;
    overflow: hidden;
    z-index: 1;
    &-bodybg{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: rgba(0,0,0,.2)
    }
    &-bg{
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        z-index: 0;background:#5fb9bf;
        &>img{
            width: 100%; height: 100%;
            object-fit: cover;
            filter: blur(0px);
        }
    }
    &-body{
        position: absolute;
        top: @mg-default; left: @mg-default; right: @mg-default;
        z-index: 1;
        & .left{
          width: 100%; overflow: hidden;
        }
        & .set{
          position: absolute;
          right: 0;
          top: 0;
          z-index: 2;
          color: #f8f8f8;
        }
    }
    &-statusbar{
        position: absolute;
        top:45%; right: 0;
        line-height: .3rem;
        padding: 0 .1rem;
        border-radius:.15rem 0 0 .15rem;
        background-color: #4fc852;
        color: white;
    }
    &-statusbarwhite{
        background-color: white;
        color: #4fc852;
    }
    &-footer{
        position: absolute;
        bottom: .08rem; left: @mg-default; right: @mg-default;
        &__price{
            position: absolute;
            right: 0;
            bottom: 0;
            &:before{
                content: '¥';
                font-size: .12rem;
                margin-right: .02rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CoachCourseCard.vue